// extracted by mini-css-extract-plugin
export default {"content":"About_content__gCq-X","sections":"About_sections__5Wa8C","footer":"About_footer__dV8ZD","nft-portal-link":"About_nft-portal-link__eKa9R"};